module.exports = require("./interopRequireDefault.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/interop-require-default.js
 ** module id = 147
 ** module chunks = 1
 **/